import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../../components/AppShell'
import { DesaList } from '../../../components/DesaList'
import { useDesaList, useLogout, useSession } from '../../../hooks/useApi'

export const Route = createFileRoute('/platform/desa/')({
  component: DesaListPage,
})

function DesaListPage() {
  const { data: session } = useSession()
  const { data: desaList, isLoading, refetch } = useDesaList()
  const logout = useLogout()
  const user = session?.user

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? 'Admin'}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <DesaList desaList={desaList} isLoading={isLoading} onRefresh={() => refetch()} />
    </AppShell>
  )
}
